import { useState, useEffect } from 'react';
import { trackEvent } from '../../../utils/analytics';

const tabs = [
  { id: 'hero', icon: 'ri-home-5-line', activeIcon: 'ri-home-5-fill', label: 'Home' },
  { id: 'prodotti', icon: 'ri-box-3-line', activeIcon: 'ri-box-3-fill', label: 'Prodotti' },
  { id: 'tecnica', icon: 'ri-settings-3-line', activeIcon: 'ri-settings-3-fill', label: 'Tecnica' },
  { id: 'form', icon: 'ri-file-list-3-line', activeIcon: 'ri-file-list-3-fill', label: 'Preventivo' },
];

export default function MobileBottomBar() {
  const [active, setActive] = useState('hero');

  useEffect(() => {
    const sections = tabs.map((t) => document.getElementById(t.id)).filter(Boolean) as HTMLElement[];

    const observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((e) => e.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActive(visible.target.id);
      },
      { threshold: 0.4 }
    );

    sections.forEach((s) => observer.observe(s));
    return () => observer.disconnect();
  }, []);

  const handleNav = (id: string, label: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setActive(id);
    trackEvent('nav_click', label, 'mobile_bar');
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-[#0D0D0D] border-t border-white/10">
      <div className="flex items-center">
        {/* 4 nav tabs */}
        {tabs.map((tab) => {
          const isActive = active === tab.id;
          return (
            <button
              key={tab.id}
              onClick={() => handleNav(tab.id, tab.label)}
              className="flex-1 flex flex-col items-center justify-center py-2.5 gap-0.5 cursor-pointer transition-all duration-200"
            >
              <div className={`w-9 h-9 flex items-center justify-center rounded-xl transition-all duration-200 ${
                isActive ? 'bg-[#7FCDCD]/15' : ''
              }`}>
                <i className={`${isActive ? tab.activeIcon : tab.icon} text-xl ${
                  isActive ? 'text-[#7FCDCD]' : 'text-white/40'
                }`} />
              </div>
              <span
                className={`text-[10px] font-semibold transition-colors duration-200 ${
                  isActive ? 'text-[#7FCDCD]' : 'text-white/30'
                }`}
                style={{ fontFamily: "'DM Sans', sans-serif" }}
              >
                {tab.label}
              </span>
            </button>
          );
        })}

        {/* WhatsApp CTA */}
        <a
          href="https://wa.me/393939932439?text=Ciao%2C%20sono%20interessato%20a%20un%20preventivo%20per%20cassonetti%20o%20controtelai."
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackEvent('whatsapp_click', 'WhatsApp – barra mobile', 'mobile_bar')}
          className="flex flex-col items-center justify-center py-2.5 px-4 gap-0.5 cursor-pointer"
        >
          <div className="w-9 h-9 flex items-center justify-center rounded-xl bg-green-500/15">
            <i className="ri-whatsapp-fill text-xl text-green-400" />
          </div>
          <span
            className="text-[10px] font-semibold text-green-400/70"
            style={{ fontFamily: "'DM Sans', sans-serif" }}
          >
            WhatsApp
          </span>
        </a>
      </div>

      {/* iPhone safe area */}
      <div className="h-safe-bottom bg-[#0D0D0D]" style={{ paddingBottom: 'env(safe-area-inset-bottom)' }} />
    </nav>
  );
}
